import styles from './LoginPage.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import contry from 'assets/images/kuwait-flag.png';
import { loginPageActions } from '../../../../stores/_actions';
import Validator from '../../../common/common-functions';
import { Button } from 'semantic-ui-react';
import popClose from 'assets/images/pop-close.svg';
import popup from '../../../components/popup/PopupModel.module.scss';

function LoginPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const customerCode = localStorage.getItem('CustomerCode');
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      DeviceID: '',
      IDNO: '',
      MobileNo: '',
      MPIN: '',
    },
    Status: false,
    SessionID: null,
    IdType: null,
  };
  const [pin, setPin] = useState({
    MPIN: '',
    IDNO: '',
    MobileNo: '',
  });
  const [submitted, setSubmitted] = useState(false);
  let logging;
  let loginMsg;
  useSelector((state) => {
    logging = state.authentication;
    // setTimeout(() => {sessionId ? history.push('/home') : history.push('/');},100);
  }, []);
  let openPopup = false;

  useEffect(() => {
    localStorage.removeItem('term');
    // sessionId ? history.push('/home') : localStorage.removeItem('userProfile');
  }, []);

  const hidePopup = () => {
    openPopup = false;
    if (logging.user?.statusCode && logging.user?.statusCode == '404') {
      history.push({ pathname: '/register' });
    }
    dispatch(loginPageActions.resetData());
  };

  if (logging.user?.statusCode === '404') {
    openPopup = true;
  } else {
    openPopup = false;
  }

  let errorMsgIdno = '';
  let errorMsgpin = '';

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == 'one' || name == 'two' || name == 'three' || name == 'four' || name == 'five' || name == 'six') {
      if (!value) {
        setPin((pin) => ({ ...pin, [name]: value, errorMsgpin: 'Enter 6 digit MPIN' }));
        return;
      }
      setPin((pin) => ({ ...pin, errorMsgpin: '' }));
      const checkValidMpin = Validator.digitsOnly(value);
      if (!checkValidMpin) {
        errorMsgpin = 'MPIN field supports only Numerics.';
        setPin((pin) => ({ ...pin, [name]: value }));
        setPin((pin) => ({ ...pin, errorMsgpin: errorMsgpin }));
        return;
      }
    }
    if (name == 'MobileNo') {
      if (!value) {
        setPin((pin) => ({ ...pin, [name]: value, errorMsg: 'Please enter Mobile Number' }));
        return;
      }
      if (value.length > 8) return;
      setPin((pin) => ({ ...pin, errorMsg: '' }));
      const checkNumber = Validator.digitsOnly(value);
      if (!checkNumber && value) {
        errorMsg = 'Mobile Number should be Numeric';
        setPin((pin) => ({ ...pin, [name]: value }));
        setPin((pin) => ({ ...pin, errorMsg: errorMsg }));
        return;
      }
      if (value.length > 8) return;
      pin.prevMobNo = value;
      pin.MobileNo = value;
      setPin((pin) => ({ ...pin, [name]: value }));
    }

    if (name == 'IDNO') {
      setPin((pin) => ({ ...pin, errorMsgIdno: '' }));
      const checkNumber = Validator.digitsOnly(value);
      if (!checkNumber) {
        errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
        setPin((pin) => ({ ...pin, [name]: value }));
        setPin((pin) => ({ ...pin, errorMsgIdno: errorMsgIdno }));
        return;
      }
      pin.prevIDNo = value;
      pin.IDNO = value;
      setPin((pin) => ({ ...pin, [name]: value, errorMsg: '' }));
    }

    setPin((pin) => ({ ...pin, [name]: value }));
  };

  let errorMsg = '';
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    let error = false;
    const checkNumber = Validator.digitsOnly(pin.MobileNo);
    if (!pin.MobileNo) {
      setPin((pin) => ({ ...pin, errorMsg: 'Please enter Mobile Number' }));
      error = true;
    } else if (!checkNumber) {
      errorMsg = 'Mobile Number should be Numeric';
      setPin((pin) => ({ ...pin, errorMsg: errorMsg }));
      error = true;
    } else if (pin.MobileNo.length < 8) {
      setPin((pin) => ({ ...pin, errorMsg: 'Please enter 8 digit valid Mobile Number' }));
      error = true;
    }
    const checkIDNumber = Validator.digitsOnly(pin.IDNO);
    if (!pin.IDNO) {
      setPin((pin) => ({ ...pin, errorMsgIdno: 'Please enter KUWAIT CIVIL ID Number' }));
      error = true;
    } else if (!checkIDNumber) {
      errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
      setPin((pin) => ({ ...pin, errorMsgIdno: errorMsgIdno }));
      error = true;
    } else if (pin.IDNO.length < 12 || pin.IDNO.length > 12) {
      setPin((pin) => ({ ...pin, errorMsgIdno: 'Please enter 12 digit valid KUWAIT CIVIL ID Number' }));
      error = true;
    }
    const checkValidMpin =
      Validator.digitsOnly(pin.one) &&
      Validator.digitsOnly(pin.two) &&
      Validator.digitsOnly(pin.three) &&
      Validator.digitsOnly(pin.four) &&
      Validator.digitsOnly(pin.five) &&
      Validator.digitsOnly(pin.six);
    if (!pin.one || !pin.two || !pin.three || !pin.four || !pin.five || !pin.six) {
      setPin((pin) => ({ ...pin, errorMsgpin: 'Enter 6 digit MPIN' }));
      error = true;
    } else if (!checkValidMpin) {
      errorMsgpin = 'MPIN field supports only Numerics.';
      setPin((pin) => ({ ...pin, errorMsgpin: errorMsgpin }));
      error = true;
    }
    if (error) {
      return;
    }
    if (pin.one && pin.six) {
      payload.Data['MPIN'] = `${pin.one}${pin.two}${pin.three}${pin.four}${pin.five}${pin.six}`;
      payload.Data['MobileNo'] = Label.Login.mobileCountryCode + pin.MobileNo;
      payload.Data['DeviceID'] = pin.IDNO;
      payload.Data['IDNO'] = pin.IDNO;
      dispatch(loginPageActions.login(payload));
    }

    setTimeout(() => {
      if (logging.user?.statusCode === '200' || logging.user?.statusCode == 200) {
        history.push('/home');
      }
    }, 10);
  };

  const message = 'You have not logged.';
  const forgotRedirection = () => {
    history.push({ pathname: '/forgot-pin', state: {} });
  };

  // start Autofocus with textbox //
  const useMountEffect = (fun) => useEffect(fun, []);
  const UseFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [input1Val, setInput1Val] = useState('');
  const [input2Val, setInput2Val] = useState('');
  const [input3Val, setInput3Val] = useState('');
  const [input4Val, setInput4Val] = useState('');
  const [input5Val, setInput5Val] = useState('');
  const [input6Val, setInput6Val] = useState('');
  const [input1Ref, setInput1Focus] = UseFocus();
  const [input2Ref, setInput2Focus] = UseFocus();
  const [input3Ref, setInput3Focus] = UseFocus();
  const [input4Ref, setInput4Focus] = UseFocus();
  const [input5Ref, setInput5Focus] = UseFocus();
  const [input6Ref, setInput6Focus] = UseFocus();
  const [completeBtnRef, setCompleteFocus] = UseFocus();

  // useMountEffect(setInput1Focus);
  // end Autofocus with textbox //

  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.Login.heading}</h1>
          <form name="login" onSubmit={handleSubmit} autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.Login.mobileNumber}</label>
              <input
                type="text"
                name="MobileNo"
                maxLength="8"
                autoComplete="off"
                value={pin.MobileNo}
                onChange={handleChange}
                className={styles.contrycode}
              />
              <div className={styles.dropdown}>
                <button type="button">
                  <img src={contry} />+{Label.Login.mobileCountryCode}
                </button>
                <div className={styles.dropdown__droppop}>
                  <a href="#">item</a>
                </div>
              </div>
              <div className={styles.formgroup__error}>{pin.errorMsg}</div>
              {/* {submitted && !pin.MobileNo && <div className={styles.formgroup__error}>Please enter Mobile Number</div>}
               */}
            </div>
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.Login.qatarIdNumber}</label>
              <input type="text" name="IDNO" maxLength="12" autoComplete="off" value={pin.IDNO} onChange={handleChange} />
              <div className={styles.formgroup__error}>{pin.errorMsgIdno}</div>
              {/* {submitted && !pin.IDNO && <div className={styles.formgroup__error}>Please enter KUWAIT CIVIL ID</div>} */}
            </div>

            <div className={styles.LoginPage__formgroup}>
              <label>{Label.Login.formLabelPin}</label>
            </div>
            <div className={styles.LoginPage__formgroup2}>
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="1"
                name="one"
                autoComplete="off"
                value={pin.one}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput1Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput2Focus();
                }}
                ref={input1Ref}
                className={styles.width7}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="2"
                name="two"
                autoComplete="off"
                value={pin.two}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput2Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput3Focus();
                }}
                ref={input2Ref}
                className={styles.width7}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="3"
                name="three"
                autoComplete="off"
                value={pin.three}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput3Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput4Focus();
                }}
                ref={input3Ref}
                className={styles.width7}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="4"
                name="four"
                autoComplete="off"
                value={pin.four}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput4Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput5Focus();
                }}
                ref={input4Ref}
                className={styles.width7}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="5"
                name="five"
                autoComplete="off"
                value={pin.five}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput5Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput6Focus();
                }}
                ref={input5Ref}
                className={styles.width7}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="6"
                name="six"
                autoComplete="off"
                value={pin.six}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput6Val(val);
                  handleChange(e);
                  if (val.length === 1) setCompleteFocus();
                }}
                ref={input6Ref}
                className={styles.width7}
              />

              {/* {submitted && !(pin.six && pin.two && pin.three && pin.four && pin.five && pin.one) && (
                <div className={styles.formgroup__error}>Enter 6 digit MPIN</div>
              )} */}
            </div>
            <div className={styles.formgroup__error}>{pin.errorMsgpin}</div>

            <input type="submit" value={Label.Login.buttonLabel} className={styles.LoginPage__link} />
            {submitted &&
            logging.user &&
            logging.user?.response == null &&
            logging.user?.statusCode !== '200' &&
            logging.user?.statusCode !== '201' &&
            logging.user?.statusCode !== '404' ? (
              <div className={styles.formgroup__error}>
                <h5>{logging.user?.message}</h5>
              </div>
            ) : (
              ''
            )}
          </form>
          <p className={styles.LoginPage__alrmember}>
            <Link onClick={forgotRedirection}>Forgot MPIN?</Link>
          </p>
          <p className={styles.LoginPage__alrmember}>
            If you not registered? <Link to="/register">Register!</Link>
          </p>
        </div>
        {openPopup ? (
          <div className={popup.dialogue}>
            <div className={popup.dialogue__wrap}>
              <img className={popup.dialogue__close} src={popClose} onClick={hidePopup} />
              {logging.user?.statusCode === '404' && (
                <>
                  <p>{logging.user?.message}</p>
                  <br />
                </>
              )}
              {/* <p>It looks like your have not registered with us before. Please click below to register with before proceeding ahead.</p> */}
              <div className={styles.pageLeft__buttonCenter} style={{ textAlign: 'center' }}>
                {/* <Link onClick={hidePopup}>OK</Link> */}
                <Button onClick={hidePopup} className="ui button">
                  {' '}
                  OK
                </Button>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </LoadingIndicator>
  );
}

export { LoginPage };
